import React, { useState } from "react";
import "../styles/Profile.css";
import { useAdmin } from "../contexts/AdminContext";

const Profile = () => {
  const { admin } = useAdmin();
  const [isProfileEditing, setIsProfileEditing] = useState(false);

  const superAdminPermissions = [
    "overview",
    "userManagement",
    "membershipManagement",
    "dietPlanManagement",
    "exerciseManagement",
    "gstInvoiceAndAgreement",
    "trainerManagement",
    "bookingManagement",
    "postManagement",
    "notificationManagement",
    "termsandconditions",
    "settingsAndAdminControls",
  ];

  return (
    <div className="profileMainContainer">
      <h2>Profile</h2>

      {admin?._id && (
        <div className="addUserProfileInput">
          <label>ID</label>
          <input type="text" value={admin.trainerId || admin._id} readOnly />
        </div>
      )}

      {admin?.name && admin?.username && (
        <div className="addUserProfileInput">
          <label>Username</label>
          <input type="text" value={admin.username} readOnly />
        </div>
      )}
      {(admin?.name || admin?.username) && (
        <div className="addUserProfileInput">
          <label>Name</label>
          <input type="text" value={admin.name || admin.username} readOnly />
        </div>
      )}

      {(admin?.phone || admin?.contact) && (
        <div className="addUserProfileInput">
          <label>Phone</label>
          <input type="text" value={admin.phone || admin.contact} readOnly />
        </div>
      )}

      {admin?.gender && (
        <div className="addUserProfileInput">
          <label>Gender</label>
          <input type="text" value={admin.gender} readOnly />
        </div>
      )}

      {admin?.age && (
        <div className="addUserProfileInput">
          <label>Age</label>
          <input type="text" value={admin.age} readOnly />
        </div>
      )}

      {admin?.address && (
        <div className="addUserProfileInput">
          <label>Address</label>
          <input type="text" value={admin.address} readOnly />
        </div>
      )}

      <h3 style={{ marginTop: 20 }}>Permissions:</h3>
      <div className="slider-container">
        <div className="slider">
          {admin.isSuperAdmin ? (
            superAdminPermissions.map((title, index) => (
              <div key={index} className="slider-item">
                <p>{title.charAt(0).toUpperCase() + title.slice(1)}</p>
                <label>
                  <input
                    type="checkbox"
                    checked={true}
                    // disabled
                    style={{
                      width: "25px",
                      height: "25px",
                      cursor: "not-allowed",
                    }}
                  />
                </label>
              </div>
            ))
          ) : admin?.permissions ? (
            Object.keys(admin.permissions).map((title, index) => (
              <div key={index} className="slider-item">
                <p>{title.charAt(0).toUpperCase() + title.slice(1)}</p>
                <label>
                  <input
                    type="checkbox"
                    checked={admin.permissions[title] || false}
                    disabled={!admin.permissions[title]}
                    style={{
                      width: "25px",
                      height: "25px",
                      cursor: admin.permissions[title]
                        ? "pointer"
                        : "not-allowed",
                    }}
                  />
                </label>
              </div>
            ))
          ) : (
            <p>No permissions assigned</p>
          )}
        </div>
      </div>

      <div className="gstSettingBtnContainer">
        {isProfileEditing ? <button>Save</button> : <button>Edit</button>}
      </div>
    </div>
  );
};

export default Profile;
